import {Box, Stack, Typography} from '@mui/material';
import {t} from 'i18next';
import {ProcessingSettingsData} from '../../../../types/upload-new-eviidence/evidenceSourceTypes';

interface DefaultProcessingSettingsProps {
  settingsDetails: ProcessingSettingsData;
}

interface SummaryItemProps {
  label: string;
  value: string | undefined;
}

const SummaryItem = ({label, value}: SummaryItemProps) => {
  return (
    <Stack>
      <Typography
        className="typo-text label1_size item-title-label"
        tabIndex={-1}
      >
        {label}
      </Typography>
      <Typography
        className="typo-text body2_size item-value-label"
        tabIndex={-1}
      >
        {value ?? '--'}
      </Typography>
    </Stack>
  );
};

const getBooleanLabel = (value?: boolean) => {
  if (value === undefined) return value;

  return value
    ? t('evidenceSource.initiateProcess.enabled')
    : t('evidenceSource.initiateProcess.disabled');
};

const DefaultProcessingSettings = ({
  settingsDetails,
}: DefaultProcessingSettingsProps) => {
  return (
    <Box>
      <Typography
        className="typo-text subhead3_size processing-settings-title"
        tabIndex={-1}
      >
        {t('evidenceSource.initiateProcess.defaultProcessingSettings')}
      </Typography>
      <Typography
        className="typo-text body3_size processing-settings-subtitle"
        tabIndex={-1}
      >
        {t('evidenceSource.initiateProcess.processingSettingSubTitle')}
      </Typography>
      <Box className="processing-settings-details">
        <Stack direction="row" spacing={2}>
          <Stack spacing={2} className="left-stack">
            <SummaryItem
              label={t('evidenceSource.initiateProcess.processingPriority')}
              value={settingsDetails.processingPriority}
            />

            <SummaryItem
              label={t('evidenceSource.initiateProcess.geographyLocation')}
              value={settingsDetails.geography}
            />

            <SummaryItem
              label={t('evidenceSource.initiateProcess.timeZone')}
              value={settingsDetails.timezone}
            />

            <SummaryItem
              label={t('evidenceSource.initiateProcess.defaultDeDuplication')}
              value={settingsDetails.defaultDeDuplication}
            />

            <SummaryItem
              label={t('common.projectServiceType')}
              value={settingsDetails.auroraType}
            />
          </Stack>
          <Stack spacing={2} className="right-stack">
            <SummaryItem
              label={t(
                'evidenceSource.initiateProcess.opticalCharacterRecognition'
              )}
              value={settingsDetails.opticalCharacterRecognition}
            />
            <SummaryItem
              label={t(
                'evidenceSource.initiateProcess.destinationReviewPlatform'
              )}
              value={settingsDetails.destinationReviewPlatform}
            />
            <SummaryItem
              label={t('evidenceSource.initiateProcess.coreECI')}
              value={getBooleanLabel(settingsDetails.coreECI)}
            />
            <SummaryItem
              label={t('evidenceSource.initiateProcess.aiInvestigate')}
              value={getBooleanLabel(settingsDetails.aiInvestigate)}
            />
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
};

export default DefaultProcessingSettings;
